<template>
  <div class="line-changed-desc d-flex align-items-center mb-2">
    <span class="x-svg-icon"
      ><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 0C4.91979 0 0 4.92022 0 11C0 17.0802 4.92022 22 11 22C17.0802 22 22 17.0798 22 11C22 4.91979 17.0797 0 11 0ZM11 20.2812C5.86983 20.2812 1.71875 16.1298 1.71875 11C1.71875 5.86983 5.87018 1.71875 11 1.71875C16.1302 1.71875 20.2812 5.87018 20.2812 11C20.2812 16.1302 16.1298 20.2812 11 20.2812Z"
          fill="#EDA906"
        />
        <path
          d="M11 9.20947C10.5254 9.20947 10.1406 9.59422 10.1406 10.0688V15.6029C10.1406 16.0776 10.5254 16.4623 11 16.4623C11.4746 16.4623 11.8594 16.0775 11.8594 15.6029V10.0688C11.8594 9.59422 11.4746 9.20947 11 9.20947Z"
          fill="#EDA906"
        />
        <path
          d="M11 8.15723C11.6407 8.15723 12.1602 7.63781 12.1602 6.99707C12.1602 6.35633 11.6407 5.83691 11 5.83691C10.3593 5.83691 9.83984 6.35633 9.83984 6.99707C9.83984 7.63781 10.3593 8.15723 11 8.15723Z"
          fill="#EDA906"
        />
      </svg>
    </span>
    <div class="text">
      {{ $t('BetSlip.LineChangedBets2') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LineChangedDesc',
};
</script>
<style lang="scss">
.line-changed-desc {
  background: #fdf6e6;
  padding: 10px;
  .x-svg-icon {
    margin-right: 15px;
  }
  .text {
    color: #343a40;
    font-size: 12px;
  }
}
</style>
